module.exports = __webpack_public_path__ + "static/img/Hex_3.dbc3770.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mobile/Mobile_Landing/Hex_3.png
// module id = IGM7
// module chunks = 0